import { CopyIcon } from "@radix-ui/react-icons";
import { Button, ButtonColor, ButtonFill, ButtonSize } from "components/Button";
import { frameCode } from "util/embed";
import Notifications from "util/notifications";

/** A website inquiry form's page: anyone with it can fill the form out. */
export function inquiryLink(publicId: string): string {
  return `${window.location.origin}/f/inquiry/${publicId}`;
}

/**
 * What a business pastes into its own website: the form in a frame, and a
 * few lines that grow the frame to fit the form (the page posts its height),
 * built as the booking widgets' code is (util/embed.ts).
 */
export function embedCode(publicId: string, formName: string): string {
  return frameCode({
    src: inquiryLink(publicId),
    title: formName,
    height: 900,
    maxWidth: 640,
  });
}

function copy(text: string, done: string) {
  navigator.clipboard
    .writeText(text)
    .then(() => Notifications.success(done))
    .catch(() => Notifications.error("Could not copy. Try again."));
}

/** Copy link and Copy embed code, for a website inquiry form. */
export default function InquiryLinks({
  publicId,
  formName,
}: {
  publicId: string;
  formName: string;
}) {
  return (
    <span className="inline-flex gap-2">
      <Button
        color={ButtonColor.SKYBLUE}
        fill={ButtonFill.HOLLOW}
        size={ButtonSize.SMALL}
        aria-label={`Copy the link to ${formName}`}
        onClick={(e) => {
          e.stopPropagation();
          copy(inquiryLink(publicId), "Link copied.");
        }}
      >
        <CopyIcon /> Copy link
      </Button>
      <Button
        color={ButtonColor.SKYBLUE}
        fill={ButtonFill.HOLLOW}
        size={ButtonSize.SMALL}
        aria-label={`Copy the code to put ${formName} on your website`}
        onClick={(e) => {
          e.stopPropagation();
          copy(
            embedCode(publicId, formName),
            "Code copied. Paste it into your website."
          );
        }}
      >
        <CopyIcon /> Copy embed code
      </Button>
    </span>
  );
}
